export default __webpack_public_path__ + "static/media/personal@3x.b3cdb2e3.png";